
export const accionOpcionTodos = { id: 0, displayName: 'TODOS' };

export const accionCambioPrecioId = 14;